import { render } from "./SupplierGroupAnalytics.vue?vue&type=template&id=7be47d49"
import script from "./SupplierGroupAnalytics.vue?vue&type=script&lang=js"
export * from "./SupplierGroupAnalytics.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__